import { render } from "./FragrancePerformanceTable.vue?vue&type=template&id=2674ecc1&scoped=true"
import script from "./FragrancePerformanceTable.vue?vue&type=script&lang=js"
export * from "./FragrancePerformanceTable.vue?vue&type=script&lang=js"

import "./FragrancePerformanceTable.vue?vue&type=style&index=0&id=2674ecc1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2674ecc1"]])

export default __exports__